module.exports = __webpack_public_path__ + "static/img/yidong.7972bf0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yidong.jpg
// module id = gpLB
// module chunks = 0